export default "__VITE_ASSET__Bzn0QkSp__"